"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Google = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function Google(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.86001C14 10.6267 12.5267 14 8.08667 14C6.48413 14.0107 4.9429 13.3847 3.80162 12.2597C2.66033 11.1346 2.01233 9.60254 2 8.00001C2.01233 6.39748 2.66033 4.8654 3.80162 3.74036C4.9429 2.61532 6.48413 1.98936 8.08667 2.00001C9.46712 2.00513 10.8057 2.47479 11.8867 3.33334C11.9236 3.36353 11.9539 3.40102 11.9757 3.44346C11.9975 3.48591 12.0103 3.53239 12.0133 3.58001C12.0135 3.62823 12.0042 3.67602 11.9859 3.72064C11.9676 3.76525 11.9407 3.80582 11.9067 3.84001C11.4727 4.23681 11.0588 4.65511 10.6667 5.09335C10.6117 5.1539 10.5359 5.1916 10.4545 5.19901C10.373 5.20642 10.2917 5.18298 10.2267 5.13335C9.61076 4.67753 8.85918 4.44266 8.09333 4.46668C7.14739 4.46668 6.2402 4.84245 5.57132 5.51133C4.90244 6.18021 4.52667 7.08741 4.52667 8.03335C4.52667 8.97928 4.90244 9.88648 5.57132 10.5554C6.2402 11.2242 7.14739 11.6 8.09333 11.6C10.0933 11.6 10.94 10.7467 11.38 9.23335H8.33333C8.24493 9.23335 8.16014 9.19823 8.09763 9.13571C8.03512 9.0732 8 8.98842 8 8.90001V7.13335C8 7.04494 8.03512 6.96016 8.09763 6.89764C8.16014 6.83513 8.24493 6.80001 8.33333 6.80001H13.6667C13.7408 6.79955 13.8124 6.82654 13.8678 6.87578C13.9232 6.92502 13.9584 6.99302 13.9667 7.06668C13.9914 7.33037 14.0025 7.59517 14 7.86001Z",
    fill: "currentColor"
  }));
}

exports.Google = Google;